import { colors } from "helpers/colors";
import React from "react";
import { createUseStyles } from "react-jss";
import Offer2 from "./Offer2";

interface IProps {
  offers: any[];
}

export default function Template2(props: IProps) {
  const { offers } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {offers.map((offer) => (
        <div
          key={`template2-${offer.id}-${Math.random()}`}
          style={{
            width: 1920 / 2,
            height: 1080,
            display: "flex",
            position: "relative",
          }}
          className={"offer-container"}
        >
          <Offer2 offer={offer} />
        </div>
      ))}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    height: "100%",
    width: "100%",
    "& .offer-container": {
      boxSizing: "border-box",
      "&:nth-child(odd)": {
        borderRight: `3px solid ${colors.imko}`,
      },
      "&:nth-child(even)": {
        borderLeft: `3px solid ${colors.imko}`,
      },
    },
  },
});
